import { useState } from "react";
import { TbCopy, TbCheck } from "react-icons/tb";
import useLabels from "../hooks/useLabels";
import "./Generic/styles/toast/index.scss";

/**
 * Body custom per i toast di errore: mostra il messaggio e un footer con il
 * reqId (codice errore) + bottone per copiarlo negli appunti.
 *
 * @param {string} message - messaggio d'errore già localizzato
 * @param {string} refText - testo del footer (es. "Codice errore: abc123")
 * @param {string} reqId   - codice da copiare negli appunti
 */
const ErrorToastBody = ({ message, refText, reqId }) => {
  const [copied, setCopied] = useState(false);
  const [getLabel] = useLabels();

  const handleCopy = (e) => {
    // closeOnClick è attivo sul ToastContainer: senza stopPropagation il click
    // sul bottone chiuderebbe il toast.
    e.stopPropagation();
    navigator.clipboard?.writeText(reqId);
    setCopied(true);
  };

  return (
    <div className="error_toast_body">
      <div className="error_toast_message">{message}</div>
      <div className="error_toast_footer">
        <span className="error_toast_ref">{refText}</span>
        <button
          type="button"
          className="error_toast_copy_btn"
          onClick={handleCopy}
          title={getLabel("toast_copyErrorCode")}
        >
          {copied ? <TbCheck /> : <TbCopy />}
        </button>
      </div>
    </div>
  );
};

export default ErrorToastBody;
